import { render, staticRenderFns } from "./GameRouter.vue?vue&type=template&id=873ed268&scoped=true"
import script from "./GameRouter.vue?vue&type=script&lang=js"
export * from "./GameRouter.vue?vue&type=script&lang=js"
import style0 from "./GameRouter.vue?vue&type=style&index=0&id=873ed268&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873ed268",
  null
  
)

export default component.exports